var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"flex flex-row gap-2"},[_c('simple-nav-tabs',{staticClass:"text-2xl",attrs:{"tabs":_vm.tabs,"value":_vm.current_tab},on:{"input":_vm.set_current_tab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }